/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');
require('vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css');

window.Vue = require('vue');

import store from './vuex/store';
import router from './components/router';
import Toasted from 'vue-toasted';
import VueClipboard from 'vue-clipboard2';
import PerfectScrollbar from 'vue2-perfect-scrollbar';
import VTooltip from 'v-tooltip';
import VueCookie from 'vue-cookie';
import VueMoment from 'vue-moment';
import moment from 'moment-timezone';
import i18n from '@/plugin/i18n';
import ToggleButton from 'vue-js-toggle-button';

VueClipboard.config.autoSetContainer = true;

Vue.use(VueCookie);
Vue.use(Toasted, {
    router,
    type: 'info',
    position: 'bottom-center',
    duration: 3000,
    singleton: true,
    // icon: 'fa-info-circle',
    // theme: 'primary',
    // iconPack: 'fontawesome',
});

// Vue.toasted.register(
//     'success',
//     (payload) => {
//         if (!payload.message) {
//             return 'Success Message';
//         }
//         return payload.message;
//     }, {
//         type: 'success',
//         icon: 'fa-check-circle',
//     },
// );
// Vue.toasted.register(
//     'error',
//     (payload) => {
//         if (!payload.message) {
//             return 'Error Message';
//         }
//         return payload.message;
//     }, {
//         type: 'error',
//         icon: 'fa-exclamation-triangle',
//     },
// );

moment.tz.setDefault(window.Laravel.tz);

Vue.use(VueClipboard);
Vue.use(VTooltip);
Vue.use(VueMoment, {
    moment,
});
Vue.use(ToggleButton);
Vue.use(PerfectScrollbar);

Vue.filter('renderDateTime', v => (v ? moment(v).format('YYYY-MM-DD HH:mm:ss') : ''));

const logger = require('js-logger');

const mixLoggerLevel = process.env.MIX_LOGGER_LEVEL || 'debug';

logger.useDefaults({
    formatter(messages, context) {
        messages.unshift((new Date()).toISOString());
    },
});

switch (mixLoggerLevel) {
case 'info':
    logger.setLevel(logger.INFO);
    break;
case 'warn':
    logger.setLevel(logger.WARN);
    break;
case 'error':
    logger.setLevel(logger.ERROR);
    break;
default:
    logger.setLevel(logger.DEBUG);
}
window.logger = logger;

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

Vue.component('passport-clients', require('./components/passport/Clients.vue').default);
Vue.component('passport-authorized-clients', require('./components/passport/AuthorizedClients.vue').default);
Vue.component('passport-personal-access-tokens', require('./components/passport/PersonalAccessTokens.vue').default);
Vue.component('vc-header', require('./components/cms/Header').default);
Vue.component('vc-service-account-bar', require('./components/cms/ServiceAccountBar').default);
Vue.component('vc-left-menu', require('./components/cms/LeftMenu').default);
Vue.component('vc-creator-service-account-bar', require('./components/cms/creator/ServiceAccountBar').default);

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

const app = new Vue({
    el: '#app',
    store,
    router,
    i18n,
});
